import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  ngOnInit(){
  }
//  title = 'app works 22!';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts